import styled from "styled-components";

export const StyledDashboardHeader = styled.header`

    width: 100vw;
    
    background-color: var(--color-grey-4);
    border-bottom: 1px solid var(--color-grey-3);
    padding: 20px 0;

    >div{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

`